<template>
  <transition name="fade" appear>
    <a :class="{ 'alternate-theme': alternateTheme }" v-if="external || link[0] === '#'" :href="link">
      <img src="@/assets/images/top-divider.svg" alt="" class="top-divider"/>
      <span>{{ text }}</span>
      <img src="@/assets/images/bottom-divider.svg" alt="" class="bottom-divider"/>
    </a>
    <button :class="{ 'alternate-theme': alternateTheme }" v-else>
      <img src="@/assets/images/top-divider.svg" alt="" class="top-divider"/>
      <span>{{ text }}</span>
      <img src="@/assets/images/bottom-divider.svg" alt="" class="bottom-divider"/>
    </button>
  </transition>
</template>

<script>
export default {
  name: "Button",
  props: {
    text: String,
    link: String,
    alternateTheme: Boolean,
    external: Boolean,
  },
};
</script>

<style lang="scss" scoped>
a,
button {
  font-family: "Neue Plak", sans-serif;
  font-size: 0.825rem;
  font-weight: 600;
  text-decoration: none;
  background: rgba(6, 18, 53, 0.30);  
  color: var(--white);
  border: none;
  text-transform: uppercase;
  padding: 13px 30px;
  user-select: none;
  display: inline-block;
  position: relative;
  transition: 0.2s all ease-in-out;
  text-shadow: 0px 1px 18px rgba(255, 255, 255, 0.80);  
  text-align: center;
  border-radius: 5px;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.86) 0%, rgba(0, 0, 0, 0.79) 39.05%, rgba(0, 0, 0, 0.00) 89.78%);
  box-shadow: 0px 3px 5px 0px #000 inset;
  backdrop-filter: blur(1px);
  cursor: pointer;
  .top-divider, .bottom-divider {
    position: absolute;
    left:0;
    width:100%;
    height:1px;
  }
  .top-divider {
    top:0;
  }
  .bottom-divider {
    bottom:0;
  }
  &.book {
    padding:8px 16px;
  }
  span {
    position: relative;
  }
  &:before {
    content:"";
    transition: 0.2s all ease-in-out;
    position: absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background: var(--accent);
    opacity: 0;
    border-radius: 25px;
  }
  &.alternate-theme {
    background: var(--white);
    color: var(--red);    
  }
  &.selected {
    pointer-events: none;
    background: var(--accent);
    span {
      color: var(--dark-red);      
    }
    &:before {
      opacity: 1;
    }
  }
  @media (hover: hover) {
    &:not(.disabled) {
      &:hover {        
        background: var(--black);
        border-bottom-color: var(--white);
      }
    }
  }
}
</style>